import { useState } from 'react'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Button, Checkbox } from 'baby-design'
import ScrollLockModal from 'shared/ScrollLockModal'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { DISMISSED_WELCOME_MODAL_KEY } from 'src/routes/(registry)/registry/(gift-tracker-revamp)/hooks/useWelcomeModalDismissal/useWelcomeModalDismissal'
import FloatingShapesBackground from 'src/routes/(registry)/registry/(gift-tracker-revamp)/components/WelcomeModal/components/FloatingShapesBackground'
import { WelcomeModalContentProps } from './WelcomeModal.types'
import css from './WelcomeModal.styles.scss'

const backToPreviousPage = () => {
  if (window.history.length > 1) window.history.back()
  else window.location.assign('/')
}

export const WelcomeModalContent: React.FC<WelcomeModalContentProps> = ({
  isOpen,
  closeModal,
}) => {
  const [checkboxChecked, setCheckboxChecked] = useState(false)

  const handleClose = () => {
    closeModal()
    backToPreviousPage()
  }

  const onProceed = () => {
    window.localStorage.setItem(
      DISMISSED_WELCOME_MODAL_KEY,
      JSON.stringify(checkboxChecked)
    )
    closeModal()
  }

  return (
    <ScrollLockModal
      showCloseButton
      className={css.WelcomeModal__Parent}
      handleClose={handleClose}
      isOpen={isOpen}
    >
      <div className={css.WelcomeModal}>
        <FloatingShapesBackground animated>
          <div className={css.WelcomeModal__Content}>
            <div className={css.WelcomeModal__TextContentContainer}>
              <div className={css.WelcomeModal__TextContent}>
                <h1>View your gifts</h1>
                <p>
                  Take a look at what friends and family have purchased from
                  your registry.
                </p>
              </div>
              <div className={css.WelcomeModal__RenderVisibilityCheckbox}>
                <Checkbox
                  inputProps={{
                    checked: checkboxChecked,
                    onChange: () => setCheckboxChecked(!checkboxChecked),
                    name: 'render_visibility',
                  }}
                  size="md"
                  type="secondary"
                />
                <p>Don't show this again</p>
              </div>
            </div>
            <div className={css.WelcomeModal__ButtonContainer}>
              <Button size="lg" variant="primary" onClick={onProceed}>
                Let's go!
              </Button>
              <Button size="lg" variant="tertiary" onClick={handleClose}>
                Go back
              </Button>
            </div>
          </div>
        </FloatingShapesBackground>
      </div>
    </ScrollLockModal>
  )
}

const WelcomeModal = NiceModal.create(() => {
  const modal = useModal()
  const handleClose = () => {
    modal.resolve()
    modal.hide()
  }
  return <WelcomeModalContent closeModal={handleClose} isOpen={modal.visible} />
})

export default WelcomeModal
